import { ExportModal } from "components/commons/ExportModal";
import Search from "components/commons/search";
import ViewList from "components/commons/view-list";
import { TABLE_EMPLOYEE_PRODUCTIVITY_LIST } from "configs/hr-metrics/configTableEmployeeProductivityList";
import { EmployeeProductivityFilterContainer } from "containers/hr-metrics/employee-productivity/EmployeeProductivityFilterContainer";
import icFileUp from "../../../assets/images/ic-file-up-02.svg";
import icAddSquare from "../../../assets/images/id-add-square.svg";
import Button from "../../commons/button";
import DeleteModal from "../../commons/delete-modal";
import Table from "../../commons/table";
import Toast from "../../commons/toast";


export const EmployeeProductivityList = ({
    dataList,
    isLoading,
    isDeleting,
    query,
    queryFilter,
    navigate,
    toast,
    modal,
    selectedIds,
    setShowModal,
    setSelectedIds,
    clearToast,
    onChangeQuery,
    onClickItemHandler,
    onExportHandler,
    onDelete,
}) => {

    return (
        <>
            <div className={"flex justify-between px-6 py-4 gap-3"}>
                <div className={'flex gap-3'}>
                    <Search onSearch={(search) => onChangeQuery({page: 1, search})} value={query?.search}/>
                    <EmployeeProductivityFilterContainer 
                        queryFilter={queryFilter}
                        onSubmit={(queryFilter) => onChangeQuery({...queryFilter, page: 1})} 
                    />
                    <ViewList
                        show={modal?.limit}
                        onShow={() => setShowModal({limit: true})}
                        onClose={() => setShowModal({limit: false})}
                        value={query?.limit}
                        onSelectSize={(limit) => onChangeQuery({page: 1, limit})}
                    />
                    <Button 
                        title='Export' 
                        icon={icFileUp} 
                        type='outline' 
                        disabled={!dataList?.total_result}
                        onClick={() => setShowModal({ export: true })} 
                    />
                </div>
        
                <Button title="Create Employee Productivity" icon={icAddSquare} onClick={() => navigate('/human-resource-metrics/create-employee-productivity/select-period')}/>
            </div>
            <Table
                className="my-3"
                name={TABLE_EMPLOYEE_PRODUCTIVITY_LIST.name}
                columns={TABLE_EMPLOYEE_PRODUCTIVITY_LIST.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onChangePage={(val) => onChangeQuery({page: val})}
                onClickSort={(val) => onChangeQuery(val)}
                onClickItem={onClickItemHandler}
                onSelectItem={setSelectedIds}
                loading={isLoading}
            />

            <DeleteModal
                show={modal?.delete}
                onHide={() => setShowModal({delete: false})}
                onDelete={onDelete}
                isLoading={isDeleting}
                text="Apakah anda yakin ingin menghapus data period ini ?"
            />

            <ExportModal
                title="Apakah anda yakin ingin export data period productivity ?"
                description={`Total data period productivity export: ${selectedIds?.length || dataList?.total_result}`}
                show={modal.export}
                onExportHandler={onExportHandler}
                onCancelHandler={() => setShowModal({export: false})}
            />

            <Toast
                show={toast?.isShowToast}
                message={toast?.message}
                onClose={() => clearToast()}
            />
        </>
    )
}
